export default "__VITE_ASSET__7HJXmM2W__"